import { render, staticRenderFns } from "./SettingsEdit.vue?vue&type=template&id=18a0b156&scoped=true&"
import script from "./SettingsEdit.vue?vue&type=script&lang=js&"
export * from "./SettingsEdit.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEdit.vue?vue&type=style&index=0&id=18a0b156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a0b156",
  null
  
)

export default component.exports